export default function Logo({ className = '' }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      {/* 아이콘: 건물 + 위치핀 조합 */}
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
      >
        {/* 배경 그라디언트 원 */}
        <defs>
          <linearGradient id="logo-grad" x1="0" y1="0" x2="36" y2="36" gradientUnits="userSpaceOnUse">
            <stop stopColor="#4F46E5" />
            <stop offset="1" stopColor="#7C3AED" />
          </linearGradient>
          <linearGradient id="logo-accent" x1="10" y1="8" x2="26" y2="28" gradientUnits="userSpaceOnUse">
            <stop stopColor="#A5F3FC" />
            <stop offset="1" stopColor="#E0E7FF" />
          </linearGradient>
        </defs>

        {/* 둥근 사각형 배경 */}
        <rect width="36" height="36" rx="10" fill="url(#logo-grad)" />

        {/* 건물 실루엣 */}
        <rect x="9" y="14" width="7" height="13" rx="1" fill="url(#logo-accent)" opacity="0.9" />
        <rect x="18" y="10" width="9" height="17" rx="1" fill="white" opacity="0.95" />

        {/* 건물 창문 */}
        <rect x="11" y="16" width="2" height="2" rx="0.5" fill="url(#logo-grad)" opacity="0.6" />
        <rect x="11" y="20" width="2" height="2" rx="0.5" fill="url(#logo-grad)" opacity="0.6" />
        <rect x="11" y="24" width="2" height="2" rx="0.5" fill="url(#logo-grad)" opacity="0.6" />
        <rect x="20" y="12" width="2.5" height="2" rx="0.5" fill="url(#logo-grad)" opacity="0.5" />
        <rect x="24" y="12" width="2.5" height="2" rx="0.5" fill="url(#logo-grad)" opacity="0.5" />
        <rect x="20" y="16" width="2.5" height="2" rx="0.5" fill="url(#logo-grad)" opacity="0.5" />
        <rect x="24" y="16" width="2.5" height="2" rx="0.5" fill="url(#logo-grad)" opacity="0.5" />
        <rect x="20" y="20" width="2.5" height="2" rx="0.5" fill="url(#logo-grad)" opacity="0.5" />
        <rect x="24" y="20" width="2.5" height="2" rx="0.5" fill="url(#logo-grad)" opacity="0.5" />

        {/* 큰 건물 출입구 */}
        <rect x="21.5" y="23.5" width="4" height="3.5" rx="1" fill="url(#logo-grad)" opacity="0.4" />

        {/* 위치 핀 마커 (우상단) */}
        <circle cx="29" cy="7" r="4.5" fill="#F59E0B" />
        <circle cx="29" cy="6.5" r="1.8" fill="white" />
        <path d="M29 9.5 L27.5 12 L30.5 12 Z" fill="#F59E0B" />
      </svg>

      {/* 텍스트 */}
      <div className="flex flex-col leading-none">
        <span className="text-[17px] font-extrabold tracking-tight text-gray-900">
          동탄 마스터
        </span>
        <span className="text-[11px] font-semibold tracking-[0.08em] text-indigo-500">
          GUIDE
        </span>
      </div>
    </div>
  );
}
